import { BrowserRouter } from "react-router-dom";
import "./App.css";
import Main from "./components/pages/Main";
import Layout from "./components/layouts/Layout";

function App() {
  return (
    <BrowserRouter>
      <Layout>
        <Main />
      </Layout>
    </BrowserRouter>
  );
}

export default App;
